import React from 'react';
import Checkbox from '@active/react-ui/Checkbox';
import CheckboxGroup from '@active/react-ui/CheckboxGroup';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import Locale from '@active/react-utils/i18n/Locale';

const SaveInWallet = ({ allowSavingAccount, forceSaveInWallet }) => {
  if (!allowSavingAccount) {
    return null;
  }
  return (
    <FormGroup name="savingAccount">
      <FormLabel></FormLabel>
      <FormField as={CheckboxGroup}>
        <Checkbox
          disabled={forceSaveInWallet}
          className="saving-account"
          value="true"
          tabIndex="0">
          <Locale id="checkout.lib.components.payment.checkbox.savingAccount" />
        </Checkbox>
      </FormField>
    </FormGroup>
  );
};

export default SaveInWallet;
